module.exports = __webpack_public_path__ + "static/media/2C.69a26297.jpg";